import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { UsuarioServiceService } from '../usuario-service.service';

@Component({
  selector: 'app-usuarios-pesquisa',
  templateUrl: './usuarios-pesquisa.component.html',
  styleUrls: ['./usuarios-pesquisa.component.css']
})
export class UsuariosPesquisaComponent {
 
  constructor(private usuarioServiceService: UsuarioServiceService,
    private confirmationService: ConfirmationService,
    private route : Router) {
    ; 
    }

  dados: any = []

  ngOnInit() {

    this.usuarioServiceService.pesquisar()
      .then((response) => this.dados = response);

  }

  pesquisarPorNome(nome: string) {

    if (nome === "") {
      this.usuarioServiceService.pesquisar()
        .then((response) => this.dados = response);
    }
    else {
      this.usuarioServiceService.pesquisarPorNome(nome)
        .then((response) => this.dados = response);
    }
  }

  excluirPorId(id: string){
   
      this.confirmationService.confirm({
        message: 'Tem certeza que você deseja excluir esse registro ?',
        accept: () => {

          this.usuarioServiceService.excluirPorId(id)
          .then(()=> {this.pesquisarPorNome("")});
        }
      }    
      )
    }
    
  

  alterarPorId(id: string){
        this.usuarioServiceService.excluirPorId(id)
        .then(()=> {this.pesquisarPorNome("")});
  }

  detalhe(id: string){
    this.route.navigate(['/sindicalizados/'+id])
    
}

}